<template lang='pug'>
    v-card
        crud-data-table(
            no-remove
            no-search
            v-bind='tableProps'
            @detail='submitDetail'
            :no-actions="!$can('VIEW_DETAIL_PURCHASE_INVOICE')"
            )
</template>

<script>
//
import { mapActions } from 'vuex'
import { ModelDataTable } from '@/components/reusable_components/next'
import PurchaseInvoiceService from '@/services/api/purchase/purchase-invoice'
//
export default {
    components: {
        'crud-data-table': ModelDataTable,
    },
    computed: {
        /**
         *
         */
        tableProps() {
            return {
                filters: PurchaseInvoiceService.filters,
                headers: PurchaseInvoiceService.headers,
                service: PurchaseInvoiceService,
            }
        },
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         *
         */
        submitDetail(event) {
            this.$router.push({
                name: 'purchase-invoice-detail',
                params: { id: event.item.id },
            })
        },
    },
    beforeMount() {
        this.setTitleTopBar('Listado histórico de facturas de compra')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_PURCHASE_INVOICE')) ctx.$router.push('/')
        })
    },
}
</script>